module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-4.e87987f8.png";